import type { EventsMetrics } from "../types/events-metrics";
import { buildEventsMetricsChartRows } from "./events-metrics-chart.utils";

export function buildEventsMetricsClipboardSummary(
	metrics: EventsMetrics
): string {
	const lines = [
		`Total de Eventos: ${metrics.total}`,
		...buildEventsMetricsChartRows(metrics).map(
			(row) => `${row.name}: ${row.count}`
		),
	];
	return lines.join("\n");
}
